import { FontAwesome } from "@expo/vector-icons";
import React, { useState } from "react";
import {
  Dimensions,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { Button, Centered, Row, StepHeader } from "../../../components/all";
import colors from "../../../constants/colors";
import Styles from "../../../constants/styles";
import { addFields } from "../../../reducers/auth/register";
import { setCountry } from "../../../reducers/auth/user";
import { COUNTRIES, ENABLED_COUNTRIES } from "../../../constants/countries";

export default function StepCountry({ navigation }) {
  const dispatch = useDispatch();
  const { isDoctor } = useSelector((state) => state.user);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleNext = () => {
    if (!selectedCountry) {
      alert("Please select your country");
      return;
    }

    // Save country to Redux
    dispatch(setCountry(selectedCountry));
    dispatch(addFields({ country: selectedCountry }));

    // Navigate to appropriate next step
    if (isDoctor) {
      navigation.navigate("StepProfession");
    } else {
      navigation.navigate("StepType");
    }
  };

  return (
    <>
      <ScrollView
        style={{
          ...Styles.webSmallContainer,
          marginTop: 80,
        }}
      >
        <StepHeader
          label="Select Country"
          icon={<FontAwesome name="globe" size={24} color="black" />}
          subtitle="Choose your country to get started"
        />
        
        <View
          style={{
            width: Dimensions.get("window").width,
            marginTop: 32,
            alignItems: "center",
          }}
        >
          {ENABLED_COUNTRIES.map((countryCode) => {
            const country = COUNTRIES[countryCode];
            return (
              <TouchableOpacity
                key={countryCode}
                onPress={() => setSelectedCountry(countryCode)}
                style={{
                  width: Dimensions.get("window").width * 0.9,
                  maxWidth: 400,
                  marginVertical: 8,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    padding: 20,
                    borderRadius: 12,
                    borderWidth: 2,
                    borderColor: selectedCountry === countryCode 
                      ? colors.primary 
                      : "rgba(0,0,0,0.1)",
                    backgroundColor: selectedCountry === countryCode
                      ? "rgba(108, 99, 255, 0.05)"
                      : "white",
                  }}
                >
                  <Text style={{ fontSize: 32, marginRight: 16 }}>
                    {country.flag}
                  </Text>
                  <View style={{ flex: 1 }}>
                    <Text style={{ 
                      fontSize: 18, 
                      fontWeight: selectedCountry === countryCode ? "bold" : "500",
                      color: selectedCountry === countryCode ? colors.primary : "black",
                    }}>
                      {country.name}
                    </Text>
                  </View>
                  {selectedCountry === countryCode && (
                    <View
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: 12,
                        backgroundColor: colors.primary,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesome name="check" size={14} color="white" />
                    </View>
                  )}
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
        
        <View style={{ marginBottom: 48 }} />
      </ScrollView>
      
      <Centered
        style={{
          position: "fixed",
          bottom: 32,
          backgroundColor: "white",
          width: "100%",
          paddingHorizontal: 24,
        }}
      >
        <Row style={{ marginBottom: 24 }}>
          <Button
            label="Back"
            type="secondary"
            onPress={() => navigation.goBack()}
          />
          <Button
            label="Next"
            type="primary"
            onPress={handleNext}
          />
        </Row>
      </Centered>
    </>
  );
}